module.exports = __webpack_public_path__ + "static/media/portfolio.5287fbaa.jpg";